import './instagram_message_base_parser.js.coffee'
Namespace 'Models.Parsers'

class Models.Parsers.InstagramMessageStoryMentionParser extends Models.Parsers.InstagramMessageBaseParser
  canHandle: (messageJSON) ->
    messageJSON.message_type == 'story_mention'

  parse: (messageJSON) ->
    builder = new Models.Builders.InstagramMessageStoryMentionBuilder
    @_doParse(builder, messageJSON)
    message = @_getMessage(messageJSON)
    builder.attachments = message.attachments.map((attachment) ->
      type = attachment.payload.type
      new Models.InstagramMedia(type, attachment.payload.url, attachment.name)
    )
    return builder.build()
